/* eslint-disable */
import * as Types from '../../types';

import { gql } from '@apollo/client';
export type PageInfoFieldsFragment = { __typename: 'PageInfo', endCursor: string, totalCount: number, hasNextPage: boolean };

export type CurrencyFieldsFragment = { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string };

export type MoneyFieldsFragment = { __typename: 'Money', name: string, value: number, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type MoneySeriesPointFieldsFragment = { __typename: 'MoneySeriesPoint', date: any, value: { __typename: 'Money', name: string, value: number, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type RemoteAssetFieldsFragment = { __typename: 'RemoteAsset', id: string, index: number, size: number, name: string, url: string };

export type AddressFieldsFragment = { __typename: 'Address', id: string, addressLine1: string, addressLine2?: string | null, suburb?: string | null, city: string, postCode?: string | null, status: Types.AddressStatus, country?: { __typename: 'Country', id: string, name: string, isoAlpha2: string } | null };

export type HoldingDocumentFieldsFragment = { __typename: 'HoldingDocument', title: string, published: any, file: { __typename: 'RemoteAsset', id: string, index: number, size: number, name: string, url: string }, category: { __typename: 'HoldingDocumentCategory', id: string, name: string } };

export type BankAccountFieldsFragment = { __typename: 'BankAccount', id: string, name: string, accountNumber: string, bsbCode?: string | null, ukSortCode?: string | null, routingNumber?: string | null, locked: boolean, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_AudVerifiableBankAccount_Fragment = { __typename: 'AUDVerifiableBankAccount', accountNumber: string, bsbCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_EurVerifiableBankAccount_Fragment = { __typename: 'EURVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_GbpVerifiableBankAccount_Fragment = { __typename: 'GBPVerifiableBankAccount', accountNumber: string, sortCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_NzdVerifiableBankAccount_Fragment = { __typename: 'NZDVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_UsdVerifiableBankAccount_Fragment = { __typename: 'USDVerifiableBankAccount', accountNumber: string, routingNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFields_VerifiableBankAccountImpl_Fragment = { __typename: 'VerifiableBankAccountImpl', id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } };

export type VerifiableBankAccountFieldsFragment = VerifiableBankAccountFields_AudVerifiableBankAccount_Fragment | VerifiableBankAccountFields_EurVerifiableBankAccount_Fragment | VerifiableBankAccountFields_GbpVerifiableBankAccount_Fragment | VerifiableBankAccountFields_NzdVerifiableBankAccount_Fragment | VerifiableBankAccountFields_UsdVerifiableBankAccount_Fragment | VerifiableBankAccountFields_VerifiableBankAccountImpl_Fragment;

export type BeneficialOwnerFieldsFragment = { __typename: 'BeneficialOwner', id: string, email: string, firstName: string, middleName?: string | null, lastName: string, investingEntityName: string, investingEntityPrimaryOwnerFirstName: string, investingEntityPrimaryOwnerLastName: string, addressVerificationStatus: Types.BeneficialOwnerVerificationStatus, basicDetailsVerificationStatus: Types.BeneficialOwnerVerificationStatus, identityDocumentVerificationStatus: Types.BeneficialOwnerVerificationStatus, biometricIdentityVerificationStatus: Types.BeneficialOwnerVerificationStatus, address?: { __typename: 'Address', placeId?: string | null, id: string, addressLine1: string, addressLine2?: string | null, suburb?: string | null, city: string, postCode?: string | null, status: Types.AddressStatus, country?: { __typename: 'Country', id: string, name: string, isoAlpha2: string } | null } | null };

export type AccountFieldsFragment = { __typename: 'Account', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, preferredName?: string | null, email?: string | null, dayOfBirth?: number | null, monthOfBirth?: number | null, yearOfBirth?: number | null, availableFunds?: Types.AccountAvailableFunds | null, timeZone?: string | null, frontChatHash?: string | null, isAccountLocked?: boolean | null, accountLockedReason?: string | null, hasProvidedAccountDetails: boolean, phoneNumber?: { __typename: 'PhoneNumber', phoneNumber: string, callingCode: string } | null, country?: { __typename: 'Country', id: string, callingCode: string } | null, address?: { __typename: 'Address', id: string, addressLine1: string, addressLine2?: string | null, suburb?: string | null, city: string, postCode?: string | null, status: Types.AddressStatus, country?: { __typename: 'Country', id: string, name: string, isoAlpha2: string } | null } | null, placeOfBirth?: { __typename: 'PlaceOfBirth', id: string, city: string, country: { __typename: 'Country', id: string, name: string } } | null, primaryCitizenship?: { __typename: 'Country', id: string, name: string } | null };

export type SessionFieldsFragment = { __typename: 'Session', id: string, token: any, expires: any, impersonatedBy?: { __typename: 'Admin', id: string, firstName: string, lastName: string } | null };

export type FeatureFlagFieldsFragment = { __typename: 'FeatureFlag', name: string, isEnabled: boolean };

export type AccreditationFields_RetailOnlyAccreditation_Fragment = { __typename: 'RetailOnlyAccreditation', id: string, updated: any, country: { __typename: 'Country', id: string, name: string } };

export type AccreditationFields_WholesaleAccreditation_Fragment = { __typename: 'WholesaleAccreditation', status: Types.AccreditationStatus, id: string, updated: any, document?: { __typename: 'HelloSignDocument', viewURL: string, template?: Types.HelloSignDocumentTemplate | null, signatures: Array<{ __typename: 'HelloSignSignature', id: string, isMe: boolean, name: string, email: string, status: Types.HelloSignSignatureStatus, signingURL: string, relationship: Types.HelloSignSignatureRelationship } | null> } | null, country: { __typename: 'Country', id: string, name: string } };

export type AccreditationFieldsFragment = AccreditationFields_RetailOnlyAccreditation_Fragment | AccreditationFields_WholesaleAccreditation_Fragment;

export type InvestingEntityFieldsFragment = { __typename: 'InvestingEntity', id: string, number?: string | null, address?: string | null, entityTypeEnum: Types.InvestingEntityType, trustType?: string | null, companyType?: string | null, partnershipType?: string | null, sourceOfFunds?: Types.SourceOfFundsSource | null, relationshipEnum?: Types.InvestingEntityRelationship | null, taxIdentificationNumber?: string | null, nzPrescribedInvestorRate?: Types.NzPrescribedInvestorRateBasisPoints | null, frequencyOfInvestment?: Types.InvestingEntityFrequencyOfInvestment | null, reasonForInvesting?: Types.InvestingEntityReasonForInvesting | null, canBeReset: boolean, country?: { __typename: 'Country', id: string, name: string } | null, accreditationCountry?: { __typename: 'Country', id: string, name: string } | null, accreditation?: { __typename: 'RetailOnlyAccreditation', id: string, updated: any, country: { __typename: 'Country', id: string, name: string } } | { __typename: 'WholesaleAccreditation', status: Types.AccreditationStatus, id: string, updated: any, document?: { __typename: 'HelloSignDocument', viewURL: string, template?: Types.HelloSignDocumentTemplate | null, signatures: Array<{ __typename: 'HelloSignSignature', id: string, isMe: boolean, name: string, email: string, status: Types.HelloSignSignatureStatus, signingURL: string, relationship: Types.HelloSignSignatureRelationship } | null> } | null, country: { __typename: 'Country', id: string, name: string } } | null, bankAccounts: Array<{ __typename: 'AUDVerifiableBankAccount', accountNumber: string, bsbCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } | { __typename: 'EURVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } | { __typename: 'GBPVerifiableBankAccount', accountNumber: string, sortCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } | { __typename: 'NZDVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } | { __typename: 'USDVerifiableBankAccount', accountNumber: string, routingNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } | { __typename: 'VerifiableBankAccountImpl', id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } }>, documents: Array<{ __typename: 'RemoteAsset', id: string, index: number, size: number, name: string, url: string } | null> };

export type AccountNotificationFields_AddInvestingEntityNotification_Fragment = { __typename: 'AddInvestingEntityNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_ConfirmEmailAddressNotification_Fragment = { __typename: 'ConfirmEmailAddressNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_ConfirmIdentityDocumentDetailsNotification_Fragment = { __typename: 'ConfirmIdentityDocumentDetailsNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_ProvideCityOfBirthNotification_Fragment = { __typename: 'ProvideCityOfBirthNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_ReattemptVerifyAddressNotification_Fragment = { __typename: 'ReattemptVerifyAddressNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_ReattemptVerifyBiometricIdentityNotification_Fragment = { __typename: 'ReattemptVerifyBiometricIdentityNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_VerifyAddressNotification_Fragment = { __typename: 'VerifyAddressNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_VerifyBiometricIdentityNotification_Fragment = { __typename: 'VerifyBiometricIdentityNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFields_VerifyIdentityNotification_Fragment = { __typename: 'VerifyIdentityNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type AccountNotificationFieldsFragment = AccountNotificationFields_AddInvestingEntityNotification_Fragment | AccountNotificationFields_ConfirmEmailAddressNotification_Fragment | AccountNotificationFields_ConfirmIdentityDocumentDetailsNotification_Fragment | AccountNotificationFields_ProvideCityOfBirthNotification_Fragment | AccountNotificationFields_ReattemptVerifyAddressNotification_Fragment | AccountNotificationFields_ReattemptVerifyBiometricIdentityNotification_Fragment | AccountNotificationFields_VerifyAddressNotification_Fragment | AccountNotificationFields_VerifyBiometricIdentityNotification_Fragment | AccountNotificationFields_VerifyIdentityNotification_Fragment;

export type InvestingEntityNotificationFields_AddBankAccountNotification_Fragment = { __typename: 'AddBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ConfirmAccreditationNotification_Fragment = { __typename: 'ConfirmAccreditationNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ConfirmUnsupportedCountryAccreditationNotification_Fragment = { __typename: 'ConfirmUnsupportedCountryAccreditationNotification', id: string, status: Types.NotificationStatus, sortOrder: number, country: { __typename: 'Country', id: string, name: string } };

export type InvestingEntityNotificationFields_ProvideBeneficialOwnerContactDetailsNotification_Fragment = { __typename: 'ProvideBeneficialOwnerContactDetailsNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ProvideInvestingEntityDocumentsNotification_Fragment = { __typename: 'ProvideInvestingEntityDocumentsNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ProvideSourceOfFundsNotification_Fragment = { __typename: 'ProvideSourceOfFundsNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ReattemptConfirmAccreditationNotification_Fragment = { __typename: 'ReattemptConfirmAccreditationNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_ReattemptProvideSourceOfFundsNotification_Fragment = { __typename: 'ReattemptProvideSourceOfFundsNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_RenewAccreditationNotification_Fragment = { __typename: 'RenewAccreditationNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_VerifyAudBankAccountNotification_Fragment = { __typename: 'VerifyAUDBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number, bankAccount: { __typename: 'AUDVerifiableBankAccount', accountNumber: string, bsbCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type InvestingEntityNotificationFields_VerifyBankAccountNotification_Fragment = { __typename: 'VerifyBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number };

export type InvestingEntityNotificationFields_VerifyEurBankAccountNotification_Fragment = { __typename: 'VerifyEURBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number, bankAccount: { __typename: 'EURVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type InvestingEntityNotificationFields_VerifyGbpBankAccountNotification_Fragment = { __typename: 'VerifyGBPBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number, bankAccount: { __typename: 'GBPVerifiableBankAccount', accountNumber: string, sortCode: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type InvestingEntityNotificationFields_VerifyNzdBankAccountNotification_Fragment = { __typename: 'VerifyNZDBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number, bankAccount: { __typename: 'NZDVerifiableBankAccount', accountNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type InvestingEntityNotificationFields_VerifyUsdBankAccountNotification_Fragment = { __typename: 'VerifyUSDBankAccountNotification', id: string, status: Types.NotificationStatus, sortOrder: number, bankAccount: { __typename: 'USDVerifiableBankAccount', accountNumber: string, routingNumber: string, id: string, created: any, name: string, nickname: string, status: Types.BankAccountStatus, currency: { __typename: 'Currency', id: string, name: string, symbol: string, abbreviation: string, decimalSeparator: string, thousandsSeparator: string } } };

export type InvestingEntityNotificationFieldsFragment = InvestingEntityNotificationFields_AddBankAccountNotification_Fragment | InvestingEntityNotificationFields_ConfirmAccreditationNotification_Fragment | InvestingEntityNotificationFields_ConfirmUnsupportedCountryAccreditationNotification_Fragment | InvestingEntityNotificationFields_ProvideBeneficialOwnerContactDetailsNotification_Fragment | InvestingEntityNotificationFields_ProvideInvestingEntityDocumentsNotification_Fragment | InvestingEntityNotificationFields_ProvideSourceOfFundsNotification_Fragment | InvestingEntityNotificationFields_ReattemptConfirmAccreditationNotification_Fragment | InvestingEntityNotificationFields_ReattemptProvideSourceOfFundsNotification_Fragment | InvestingEntityNotificationFields_RenewAccreditationNotification_Fragment | InvestingEntityNotificationFields_VerifyAudBankAccountNotification_Fragment | InvestingEntityNotificationFields_VerifyBankAccountNotification_Fragment | InvestingEntityNotificationFields_VerifyEurBankAccountNotification_Fragment | InvestingEntityNotificationFields_VerifyGbpBankAccountNotification_Fragment | InvestingEntityNotificationFields_VerifyNzdBankAccountNotification_Fragment | InvestingEntityNotificationFields_VerifyUsdBankAccountNotification_Fragment;

export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  endCursor
  totalCount
  hasNextPage
}
    `;
export const CurrencyFieldsFragmentDoc = gql`
    fragment currencyFields on Currency {
  id
  name
  symbol
  abbreviation
  decimalSeparator
  thousandsSeparator
}
    `;
export const MoneyFieldsFragmentDoc = gql`
    fragment moneyFields on Money {
  name
  value
  currency {
    ...currencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const MoneySeriesPointFieldsFragmentDoc = gql`
    fragment MoneySeriesPointFields on MoneySeriesPoint {
  date
  value {
    ...moneyFields
  }
}
    ${MoneyFieldsFragmentDoc}`;
export const RemoteAssetFieldsFragmentDoc = gql`
    fragment remoteAssetFields on RemoteAsset {
  id
  index
  size
  name
  url
}
    `;
export const HoldingDocumentFieldsFragmentDoc = gql`
    fragment holdingDocumentFields on HoldingDocument {
  title
  published
  file {
    ...remoteAssetFields
  }
  category {
    id
    name
  }
}
    ${RemoteAssetFieldsFragmentDoc}`;
export const BankAccountFieldsFragmentDoc = gql`
    fragment bankAccountFields on BankAccount {
  id
  name
  accountNumber
  bsbCode
  ukSortCode
  routingNumber
  locked
  currency {
    ...currencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  id
  addressLine1
  addressLine2
  suburb
  city
  postCode
  country {
    id
    name
    isoAlpha2
  }
  status
}
    `;
export const BeneficialOwnerFieldsFragmentDoc = gql`
    fragment beneficialOwnerFields on BeneficialOwner {
  id
  email
  firstName
  middleName
  lastName
  investingEntityName
  investingEntityPrimaryOwnerFirstName
  investingEntityPrimaryOwnerLastName
  addressVerificationStatus
  basicDetailsVerificationStatus
  identityDocumentVerificationStatus
  biometricIdentityVerificationStatus
  address {
    ...addressFields
    placeId
  }
}
    ${AddressFieldsFragmentDoc}`;
export const AccountFieldsFragmentDoc = gql`
    fragment accountFields on Account {
  id
  firstName
  middleName
  lastName
  preferredName
  email
  dayOfBirth
  monthOfBirth
  yearOfBirth
  availableFunds
  timeZone
  frontChatHash
  isAccountLocked
  accountLockedReason
  hasProvidedAccountDetails
  phoneNumber {
    phoneNumber
    callingCode
  }
  country {
    id
    callingCode
  }
  address {
    ...addressFields
  }
  placeOfBirth {
    id
    city
    country {
      id
      name
    }
  }
  primaryCitizenship {
    id
    name
  }
}
    ${AddressFieldsFragmentDoc}`;
export const SessionFieldsFragmentDoc = gql`
    fragment sessionFields on Session {
  id
  token
  expires
  impersonatedBy {
    id
    firstName
    lastName
  }
}
    `;
export const FeatureFlagFieldsFragmentDoc = gql`
    fragment featureFlagFields on FeatureFlag {
  name
  isEnabled
}
    `;
export const AccreditationFieldsFragmentDoc = gql`
    fragment accreditationFields on Accreditation {
  id
  updated
  country {
    id
    name
  }
  ... on WholesaleAccreditation {
    status
    document {
      viewURL
      template
      signatures {
        id
        isMe
        name
        email
        status
        signingURL
        relationship
      }
    }
  }
}
    `;
export const VerifiableBankAccountFieldsFragmentDoc = gql`
    fragment verifiableBankAccountFields on VerifiableBankAccount {
  id
  created
  name
  nickname
  status
  currency {
    ...currencyFields
  }
  ... on NZDVerifiableBankAccount {
    accountNumber
  }
  ... on AUDVerifiableBankAccount {
    accountNumber
    bsbCode
  }
  ... on USDVerifiableBankAccount {
    accountNumber
    routingNumber
  }
  ... on GBPVerifiableBankAccount {
    accountNumber
    sortCode
  }
  ... on EURVerifiableBankAccount {
    accountNumber
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const InvestingEntityFieldsFragmentDoc = gql`
    fragment investingEntityFields on InvestingEntity {
  id
  number
  address
  entityTypeEnum
  trustType
  companyType
  partnershipType
  sourceOfFunds
  relationshipEnum
  taxIdentificationNumber
  nzPrescribedInvestorRate
  frequencyOfInvestment
  reasonForInvesting
  canBeReset
  country {
    id
    name
  }
  accreditationCountry {
    id
    name
  }
  accreditation {
    ...accreditationFields
  }
  bankAccounts {
    ...verifiableBankAccountFields
  }
  documents {
    ...remoteAssetFields
  }
}
    ${AccreditationFieldsFragmentDoc}
${VerifiableBankAccountFieldsFragmentDoc}
${RemoteAssetFieldsFragmentDoc}`;
export const AccountNotificationFieldsFragmentDoc = gql`
    fragment accountNotificationFields on AccountNotification {
  id
  status
  sortOrder
}
    `;
export const InvestingEntityNotificationFieldsFragmentDoc = gql`
    fragment investingEntityNotificationFields on InvestingEntityNotification {
  id
  status
  sortOrder
  ... on VerifyNZDBankAccountNotification {
    bankAccount {
      ...verifiableBankAccountFields
    }
  }
  ... on VerifyAUDBankAccountNotification {
    bankAccount {
      ...verifiableBankAccountFields
    }
  }
  ... on VerifyEURBankAccountNotification {
    bankAccount {
      ...verifiableBankAccountFields
    }
  }
  ... on VerifyGBPBankAccountNotification {
    bankAccount {
      ...verifiableBankAccountFields
    }
  }
  ... on VerifyUSDBankAccountNotification {
    bankAccount {
      ...verifiableBankAccountFields
    }
  }
  ... on ConfirmUnsupportedCountryAccreditationNotification {
    country {
      id
      name
    }
  }
}
    ${VerifiableBankAccountFieldsFragmentDoc}`;